import React, { useState } from "react";
import { PoweroffOutlined } from "@ant-design/icons";
import { Button, Tooltip, Popconfirm, notification } from "antd";
import { rebootDevice } from "../../services/devicemanagementservice";
import { CommandResponseDto } from "../../types/devicemanagementtypes";

interface RebootButtonProps {
    deviceId: string;
    aliasName?: string;
}

const RebootButton: React.FC<RebootButtonProps> = ({ deviceId, aliasName }) => {
    const [loading, setLoading] = useState(false);

    const handleReboot = async () => {
        setLoading(true);
        try {
            const { data } = await rebootDevice(deviceId);
            const response = data as CommandResponseDto;

            if (response.success) {
                notification.success({
                    message: "Reboot Initiated",
                    description: aliasName
                        ? `Device "${aliasName}" reboot command sent successfully.`
                        : "Device reboot command sent successfully.",
                    placement: "topRight",
                });
            } else {
                notification.error({
                    message: "Reboot Failed",
                    description: response.message,
                    placement: "topRight",
                });
            }
        } catch {
            notification.error({
                message: "Unexpected Error",
                description: aliasName
                    ? `An error occurred while rebooting "${aliasName}".`
                    : "An error occurred while rebooting the device.",
                placement: "topRight",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Popconfirm
            title="Are you sure you want to reboot this device?"
            onConfirm={handleReboot}
            okText="Yes"
            cancelText="No"
        >
            <Tooltip title="Reboot Device">
                <Button
                    icon={<PoweroffOutlined style={{ color: "var(--color-primary)" }} />}
                    loading={loading}
                    disabled={loading}
                />
            </Tooltip>
        </Popconfirm>
    );
};

export default RebootButton;